import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return 'Logiciel de devis pour plâtriers-plaquistes | Topela'
}